export enum UserRole {
  ADMIN = 'admin',
  DEVELOPER = 'developer',
  CLIENT = 'client'
}

export interface Route {
  path: string;
  name: string;
  icon: string;
  component?: React.ComponentType;
}

export interface RolePermissions {
  canViewClients: boolean;
  canViewAllBots: boolean;
  canViewUsers: boolean;
  canViewDetailedCosts: boolean;
  canViewInfrastructure: boolean;
}